import { translate } from '../../../Services/translation';
import {
  ExtapiInvoiceReturnRequest,
  ExtapiInvoiceSearchQueryParams,
  InteractiveTableHeaders,
} from '../../../Types/MyPages/InvoicesModel';
import { DropdownOption } from '../../Dropdown';

export const defaultReturnRequestModel: ExtapiInvoiceReturnRequest = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  isDamagedProduct: false,
  beenInContact: false,
  beenInContactPerson: '',
  returns: [],
};

export const defaultInvoiceQueryParams: ExtapiInvoiceSearchQueryParams = {
  startDate: new Date(new Date().setMonth(new Date().getMonth() - 1))
    .toISOString()
    .split('T')[0]!,
  endDate: new Date().toISOString().split('T')[0]!,
  filterField: 'ItemNo',
  filterFieldSearchValue: '',
};

export const defaultRmaQueryParams: ExtapiInvoiceSearchQueryParams = {
  startDate: new Date(
    new Date().setFullYear(new Date().getFullYear() - 1)
  ).toLocaleDateString(),
  endDate: new Date().toLocaleDateString(),
  filterField: 'itemNo',
  filterFieldSearchValue: '',
};

export const myPagesRmaFilterDefaultOption: DropdownOption = {
  label: translate('mypage.rma.itemnumber'),
  value: 'itemNo',
};

export const myPagesInvoiceFilterOptions: DropdownOption[] = [
  {
    label: translate('mypage.rma.itemnumber'),
    value: 'ItemNo',
  },
  {
    label: translate('mypage.rma.ean'),
    value: 'EanCode',
  },
  {
    label: translate('mypage.rma.invoicenumber'),
    value: 'InvoiceNo',
  },
  {
    label: translate('mypage.rma.ordernumber'),
    value: 'OrderNo',
  },
  {
    label: translate('mypage.rma.customerordernumber'),
    value: 'CustomerOrderNo',
  },
];

export const myPagesRmaFilterOptions: DropdownOption[] = [
  {
    label: translate('mypage.rma.itemnumber'),
    value: 'itemNo',
  },
  {
    label: translate('mypage.rma.ean'),
    value: 'ean',
  },
  {
    label: translate('mypage.rma.invoicenumber'),
    value: 'invoiceNo',
  },
  {
    label: translate('mypage.rma.ordernumber'),
    value: 'orderNo',
  },
  {
    label: translate('mypage.rma.customerordernumber'),
    value: 'custOrderNo',
  },
];

export const tableHeaders: InteractiveTableHeaders[] = [
  {
    id: 'documentNo',
    displayTextName: 'mypage.rma.invoicenumber',
  },
  {
    id: 'orderNo',
    displayTextName: 'mypage.rma.ordernumber',
  },
  {
    id: 'yourOrderNo',
    displayTextName: 'mypage.rma.yourordernumber',
  },
  {
    id: 'postingDate',
    displayTextName: 'mypage.rma.postingdate',
  },
];
